import { isSameMonth } from "date-fns";
import { Highcharts, getProtLinesByTreatmentRecords } from "utils/chart";
import {
  PatientBodyWeightRecords,
  PatientTreatmentRecords,
  DateDisplayTerms,
} from "types";
import { getXaxisIntervalByTerms } from "utils/chart";

export const getChartOptions = (
  data: PatientBodyWeightRecords,
  treatmentRecords: PatientTreatmentRecords,
  terms: DateDisplayTerms
) => {
  if (data.length <= 0) return undefined;

  const yAxisMax = data.every((d) => d[1] === null) ? 100 : undefined;

  let prevDate: Date | null = null;
  const options: Highcharts.Options = {
    chart: {
      borderRadius: 16,
      spacingLeft: 0,
      spacingRight: 0,
      spacingBottom: 27,
    },
    title: {
      text: "",
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: "line",
        data,
        color: "#3488EE",
        zIndex: 99,
        lineWidth: 4,
        connectNulls: true,
        marker: {
          enabled: true,
        },
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            enabled: false,
          },
        },
      },
    ],
    xAxis: {
      title: {
        text: "",
      },
      type: "datetime",
      startOnTick: true,
      minPadding: 0,
      tickWidth: 0,
      tickLength: 0,
      gridLineWidth: 1,
      opposite: true,
      lineColor: "#e5e5e5",
      crosshair: {
        color: "#333",
        dashStyle: "Dash",
      },
      plotLines: getProtLinesByTreatmentRecords(treatmentRecords),
      tickPositioner: function () {
        const newTicks = [],
          min = this.min || 0,
          max = this.max || 0,
          interval = getXaxisIntervalByTerms(terms);

        for (let i = min; i <= max; i += interval) {
          newTicks.push(i);
        }

        return newTicks;
      },
      labels: {
        useHTML: true,
        style: {
          fontSize: "14px",
          color: "#000",
          padding: "0",
        },
        formatter: function () {
          const currentDate = new Date(this.value);

          if (prevDate == null || !isSameMonth(prevDate, currentDate)) {
            prevDate = currentDate;
            return Highcharts.dateFormat(
              '<div style="font-size: 14px; text-align: center; color: #000;"><span style="font-weight: bold; display: inline-block; margin-bottom: 2px; white-space:nowrap;">%Y年%m月</span><br><span>%e(%a)</span></div>',
              this.value as number
            );
          } else {
            prevDate = currentDate;
            return Highcharts.dateFormat("%e(%a)", this.value as number);
          }
        },
      },
    },
    yAxis: {
      title: {
        text: "",
      },
      min: 30,
      max: yAxisMax,
      tickInterval: 1,
      tickAmount: 14,
      labels: {
        useHTML: true,
        align: "right",
        x: 0,
        formatter: function () {
          if (this.isLast) {
            return '<div class="highcharts__value-label highcharts__value-unit" style="width: 130px;text-align:right; padding-right: 16px;">kg</div>';
          } else {
            return (
              '<div class="highcharts__value-label" style="width: 130px; text-align: right; padding-right:16px;">' +
              Highcharts.numberFormat(this.value as number, 0) +
              "</div>"
            );
          }
        },
      },
    },
    tooltip: {
      headerFormat: "",
      useHTML: true,
      pointFormatter: function () {
        return (
          '<div class="highcharts__tooltip-value" style="text-align: center;">' +
          this?.y?.toFixed(1) +
          "kg</div>"
        );
      },
      footerFormat: '<div class="highcharts__tooltip-date">{point.key}</div>',
      xDateFormat: "%Y.%m.%d",
      followTouchMove: true,
      backgroundColor: "#333",
      borderRadius: 4,
      borderWidth: 4,
      borderColor: "#333",
      shadow: false,
      padding: 4,
      shape: "square",
      style: {
        color: "#ffffff",
        fontSize: "10px",
      },
    },
  };

  return options;
};
